import React, { useEffect, useState } from "react";
import Header from "../../layout/Header";
import Accordion from "react-bootstrap/Accordion";
import { FaChevronDown, FaChevronUp, FaInfoCircle } from "react-icons/fa"; // Import icons
import { fetchAPI } from "../../service/Encrtyption";
import { useDispatch, useSelector } from "react-redux";
import { Loader } from "../../loader";
import { formatDate } from "../../../utils/analytics";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import { claimStatus, myRewards, reclaimDataSave, rewardMoney } from "../../auth/redux/store";
import ReactGA from 'react-ga4';
import { convertMediaUrls } from "../../../utils/authenticatedImages";
export const ClaimDetails = () => {
  const { t, i18n } = useTranslation();
  const { lang } = useParams();
  const currentLanguage = lang ? lang : i18n.language;

  const obj = {
    cashFreeTransactionId: 0,
    dsrId: 0,
    ecouponFarmerMapId: 0,
    moduleType: "Farmer",
    programId: 0,
    reClaim: "No",
    showView: false,
    countOfToBeClaims: 0,
    dsrProgramId: 0,
    ecouponFarmerId: 0,
    enableSprayService: false,
    isCortevaProduct: false,
    isLumivia: false,
    isProductAlreadyScaned: false,
    isSpinDone: false,
    lumiviaServReqRecordID: 0,
    multipleRewards: false,
    seadProgramId: 0,
    showClickableLink: false,
    showLuckyWinnerPopup: false,
    showRetailerIdPopup: false,
    uq_responseCode: 0,
    wheelStoppingIndex: 0,
    destinationURL: "/cashFreeReward/getCashFreeTransactionPendingRequest_V3",
    appLangCode: currentLanguage

  };

  const [activeKey, setActiveKey] = useState("0");
  const [formData, setFormData] = useState(obj);
  const [activeKeyAccordion1, setActiveKeyAccordion1] = useState("0");
  const [activeKeyAccordion2, setActiveKeyAccordion2] = useState("0");
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(false);
  const user = useSelector((state) => state?.user);
  const amount = useSelector((state) => state?.amount);
  const [errroMsg, setErrorMsg] = useState("");

  const mobileNumber = sessionStorage.getItem('mbn');

  const dispatch = useDispatch();

  const navigate = useNavigate();

  const handleAccordion1Toggle = (key) => {
    setActiveKeyAccordion1(key === activeKeyAccordion1 ? null : key);
  };

  const handleAccordion2Toggle = (key) => {
    setActiveKeyAccordion2(key === activeKeyAccordion2 ? null : key);
  };


  const hide = () => {
    setErrorMsg("");
  };

  const onSubmit = async () => {
    // debugger;
    setLoading(true);
    console.log(JSON.stringify(formData) + "requestdata for claimlist");

    if (!mobileNumber) {
      setErrorMsg(t("sessionExperied"));
      setTimeout(() => {
        navigate(`/${lang}/home`);
      }, 2000);
      return;
    }

    try {
      const responseData = await fetchAPI(
        process.env.REACT_APP_API_URL,
        formData,
        {
          mobileNumber: mobileNumber,
          appLangCode: currentLanguage
        }
      );
      const jsonReposneData = JSON.parse(responseData); 
      const mediaData = await convertMediaUrls(jsonReposneData); 
      dispatch(myRewards(mediaData));
      console.log("responseData for claimlist" + JSON.stringify(jsonReposneData));
      console.log("responseData for mediaData" + JSON.stringify(mediaData));
      setData(mediaData);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false); // Set loading state to false after API call is completed
    }
  };
  useEffect(() => {
    onSubmit();
  }, []);

  const labelNames = [
    {
      label: "",
    },
  ];

  const handleClaimSubmit = () => {

    ReactGA.event({
      category: 'Claim Btn',
      label: 'Claim Btn',
      action: 'Claim Amount Btn Clicked'
    });

    dispatch(claimStatus(true));
    navigate(`/${lang}/paymentmode`)
  };

  const handleReClaimSubmit = (sucess) => {

    ReactGA.event({
      category: 'Reclaim Btn',
      label: 'Reclaim Btn',
      action: 'Reclaim Amount Btn Clicked'
    });

    // debugger;
    dispatch(claimStatus(false));
    dispatch(reclaimDataSave(sucess));
    dispatch(rewardMoney(sucess.amount))
    navigate(`/${lang}/paymentmode`)
  };


  useEffect(() => {
    if (data && data.cbTransactionList && data.cbTransactionList.cbClaimList) {
      const totalAmount = data.cbTransactionList.cbClaimList.reduce(
        (total, claim) => total + parseFloat(claim.amount),
        0
      );
      dispatch(rewardMoney(totalAmount));
    }
  }, [data, dispatch]);

  return (
    <>
      <Header />
      <div className="main">
        {/* <p
          className="text-center text-primary"
          onClick={() => navigate(`/${lang}/home`)}>
            {t("noData")} 
        </p> */}
        <div className="container">
          {loading && <Loader />}

          <Accordion defaultActiveKey="0" style={{ paddingBottom: '4rem' }}>
            <Accordion.Item eventKey="0">
              <Accordion.Header> {t("delegateRewards")}</Accordion.Header>


              {data ?
                <Accordion.Body>
                  {/* subaccordin */}

                  <Accordion
                    activeKey={activeKeyAccordion1}
                    onSelect={handleAccordion1Toggle}
                  >
                    {data &&
                      data.cbTransactionList &&
                      data.cbTransactionList.cbClaimList &&
                      data.cbTransactionList.cbClaimList.length > 0 ? (
                      <Accordion.Item eventKey="0">
                        <Accordion.Header onClick={() => {
                          ReactGA.event({
                            category: 'Rewards Page',
                            label: 'Rewards Page',
                            action: 'Claim List Section Opened'
                          });
                        }}>
                          {t("claimList")}

                          {activeKeyAccordion1 === "0" ? (
                            <FaChevronUp className="float-end" />
                          ) : (
                            <FaChevronDown className="float-end" />
                          )}
                        </Accordion.Header>
                        <Accordion.Body>
                          <div>
                            <div className="d-flex flex-column gap-4">
                              {data &&
                                data.cbTransactionList &&
                                data.cbTransactionList.cbClaimList &&
                                data.cbTransactionList.cbClaimList.length >
                                0 ? (
                                data.cbTransactionList.cbClaimList.map(
                                  (claim, claimIndex) => (
                                    <div
                                      className="card"
                                      key={`claim-${claimIndex}`}
                                    >
                                      <div className="card-body p-2" style={{ fontSize: '.9rem' }}>
                                        <p className="mb-2">
                                          <span className="claimList-heading">
                                            {t("productName")}
                                          </span>
                                          : {claim.productName}
                                        </p>
                                        <p className="mb-2">
                                          <span className="claimList-heading">
                                            {t("reward")}
                                          </span>
                                          : ₹ {claim.amount}
                                        </p>
                                        <p className="mb-2 d-flex align-items-end" style={{ gap: '.2rem' }}>
                                          <span className="claimList-heading">
                                            {t("Date")}
                                          </span>
                                          : {new Date(claim.createdOn).toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit', second: '2-digit' }).replace(/,/g, '').split(' - ')}
                                        </p>
                                        {claim.prodSerialNumber && (<p className="mb-2 d-flex align-items-end" style={{ gap: '.2rem' }}>
                                          <span className="claimList-heading">
                                            {t("serialNO")}
                                          </span>
                                          : {claim.prodSerialNumber}
                                        </p>)}
                                      </div>
                                    </div>
                                  )
                                )
                              ) : (
                                <p> {t("noClaimsFound")}</p>
                              )}
                            </div>
                          </div>
                          <button
                            type="button"
                            onClick={handleClaimSubmit}
                            className="btn btn-primary w-100 py-2 center-textbtn mt-3 text-white claimBtn"
                            id="submitBtn"
                          >
                            {t("Claim")} - ₹
                            {amount}
                          </button>
                        </Accordion.Body>
                      </Accordion.Item>
                    ) : null}
                    {data &&
                      data.cbTransactionList &&
                      data.cbTransactionList.cbSuccessList &&
                      data.cbTransactionList.cbSuccessList.length > 0 ? (
                      <Accordion.Item eventKey="1">
                        <Accordion.Header onClick={() => {
                          ReactGA.event({
                            category: 'Rewards Page',
                            label: 'Rewards Page',
                            action: 'Success List Section Opened'
                          });
                        }}>
                          {t("successList")}
                          {activeKeyAccordion2 === "1" ? (
                            <FaChevronUp className="float-end" />
                          ) : (
                            <FaChevronDown className="float-end" />
                          )}
                        </Accordion.Header>
                        <Accordion.Body>
                          <div className="d-flex flex-column gap-4">
                            {data &&
                              data.cbTransactionList &&
                              data.cbTransactionList.cbSuccessList &&
                              data.cbTransactionList.cbSuccessList.length > 0 ? (
                              data.cbTransactionList.cbSuccessList.map(
                                (success, successIndex) => (

                                  <div className="card" key={`success-${successIndex}`}>
                                    <div className="card-body p-2" style={{ fontSize: '.9rem' }}>
                                      {/* <FaInfoCircle className="infoImg" /> */}
                                      <p className="mb-2 d-flex">
                                        <span className="claimList-heading">
                                          {t("reward")}
                                        </span>
                                        {/* : ₹{success.amount} */}
                                        : {
                                          !isNaN(parseFloat(success.amount)) &&
                                            isFinite(success.amount) ? `₹${success.amount}`
                                            : success.amount
                                        }
                                      </p>

                                      {success.referenceId && (<p className="mb-2">
                                        <span className="claimList-heading">
                                          {t("referenceId")}
                                        </span>
                                        : {success.referenceId}
                                      </p>
                                      )}

                                      <p className="mb-2">
                                        <span className="claimList-heading">
                                          {t("Date")}
                                        </span>
                                        : {new Date(success.createdOn).toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit', second: '2-digit' }).replace(/,/g, '').split(' - ')}
                                        {/* : {new Date(success.createdOn).toISOString().replace('T', ' ').split('.')[0]} */}
                                      </p>
                                      <p className="mb-2">
                                        <span className="claimList-heading">
                                          {t("status")}
                                        </span>
                                        : {success.status}
                                      </p>
                                    </div>
                                  </div>

                                )
                              )
                            ) : (
                              <p> {t("noSuccessList")}</p>
                            )}
                          </div>
                        </Accordion.Body>
                      </Accordion.Item>
                    ) : null}

                    {data &&
                      data.cbTransactionList &&
                      data.cbTransactionList.cbReClaimList &&
                      data.cbTransactionList.cbReClaimList.length > 0 ? (
                      <Accordion.Item eventKey="2">
                        <Accordion.Header onClick={() => {
                          ReactGA.event({
                            category: 'Rewards Page',
                            label: 'Rewards Page',
                            action: 'Reclaim List Section Opened'
                          });
                        }}>
                          {t("reclaimList")}
                          {activeKeyAccordion2 === "2" ? (
                            <FaChevronUp className="float-end" />
                          ) : (
                            <FaChevronDown className="float-end" />
                          )}
                        </Accordion.Header>
                        <Accordion.Body>
                          <div className="d-flex flex-column gap-4">

                            {data.cbTransactionList.cbReClaimList.map((success, successIndex) => (
                              <div className="card" key={`success-${successIndex}`}>
                                <div className="card-body p-2" style={{ fontSize: '.9rem' }}>
                                  <FaInfoCircle className="infoImg" />
                                  <p className="mb-2">
                                    <span className="claimList-heading">{t("reward")}</span>: ₹{success.amount}
                                  </p>

                                  {success.referenceId && (<p className="mb-2">
                                    <span className="claimList-heading">{t("referenceId")}</span>: {success.referenceId}
                                  </p>
                                  )}

                                  <p className="mb-2">
                                    <span className="claimList-heading">{t("Date")}</span>: {formatDate(success.createdOn)}
                                  </p>
                                  <p className="mb-2">
                                    <span className="claimList-heading">{t("status")}</span>: {success.status}
                                  </p>
                                  {/* Individual amount button for each card */}
                                  <button
                                    type="button"
                                    onClick={() => handleReClaimSubmit(success)}
                                    className="btn btn-primary w-100 py-2 center-textbtn mt-3 text-white claimBtn"
                                    id={`submitBtn-${successIndex}`}
                                  >
                                    {t("Reclaim")}
                                  </button>
                                  {/* Reclaim button */}

                                </div>
                              </div>
                            ))}
                          </div>
                        </Accordion.Body>
                      </Accordion.Item>
                    ) : (
                      null
                    )}
                  </Accordion>
                </Accordion.Body>

                : <p className="text-center pt-4"> {t("noData")} </p>}
            </Accordion.Item>
          </Accordion>

          {errroMsg && (
            <>
              <div
                className="alert alert-warning alert-dismissible fade show mt-2"
                role="alert"
              >
                {errroMsg}
                <button
                  type="button"
                  className="close"
                  onClick={hide}
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
            </>
          )}

          <button
            type="submit"
            className="btn btn-primary w-100 py-3
                  center-textbtn mt-3 text-white text-uppercase"
            id="submitBtn" style={{ position: 'fixed', bottom: '0', left: '0', borderRadius: '0' }}
            onClick={() => {
              ReactGA.event({
                category: 'Back To Home Btn',
                label: 'Back To Home Btn',
                action: 'Back To Home Btn Clicked'
              });
              navigate(`/${lang}/home`)
            }

            }
          >
            {t("BackToHome")}
          </button>
        </div>
      </div>
    </>
  );
};
